import type { Locale } from "../data";

export type Theme = "light" | "dark";

export const LOCALE_STORAGE_KEY = "iearn-locale";
export const THEME_STORAGE_KEY = "iearn-theme";

/** Pick the initial UI locale from a persisted value, falling back to the browser language. */
export function resolveLocale(saved: string | null | undefined, navigatorLanguage: string | undefined): Locale {
  if (saved === "zh" || saved === "en") return saved;
  return (navigatorLanguage ?? "").toLowerCase().startsWith("zh") ? "zh" : "en";
}

/** Pick the initial theme from a persisted value; anything unrecognised falls back to light. */
export function resolveTheme(saved: string | null | undefined): Theme {
  return saved === "light" || saved === "dark" ? saved : "light";
}

/** Map a UI locale to the BCP 47 tag used on `<html lang>` and in Open Graph metadata. */
export function toHtmlLang(locale: Locale): "en" | "zh-CN" {
  return locale === "zh" ? "zh-CN" : "en";
}

/**
 * Restrict an OAuth `?next=` target to a same-app path so the callback screen
 * can never bounce a user to another origin. Rejects protocol-relative (`//`)
 * and backslash (`/\`) forms, which browsers normalise to an external host.
 */
export function sanitizeNextPath(rawNext: string | null | undefined, fallback = "/"): string {
  if (!rawNext) return fallback;
  if (!rawNext.startsWith("/")) return fallback;
  const second = rawNext.charAt(1);
  if (second === "/" || second === "\\") return fallback;
  if (/[\u0000-\u001f]/.test(rawNext)) return fallback;
  return rawNext;
}
